module.exports = __webpack_public_path__ + "img/w69b.82af605b.jpg";